export type StateCriteria = {
  state: string;
  assessment: string;
  overallScore: string;
  domainSpecific?: string;
  additional?: string;
  summary?: string;
  description?: string;
};

export const STATE_CRITERIA: StateCriteria[] = [
  { state: 'Alabama', assessment: 'WIDA ACCESS', overallScore: '4.8' },
  {
    state: 'Alaska',
    assessment: 'WIDA ACCESS',
    overallScore: '4.6',
    additional: 'State rule is above 4.5 (Tier B/C); 4.6 is the lowest passing level',
  },
  { state: 'Arizona', assessment: 'AZELLA', overallScore: 'Overall Proficient' },
  { state: 'Arkansas', assessment: 'ELPA21', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains' },
  { state: 'California', assessment: 'ELPAC', overallScore: 'Overall Level 4', additional: 'Teacher evaluation; Parent consultation; Basic skills assessment' },
  { state: 'Colorado', assessment: 'WIDA ACCESS', overallScore: '4', additional: 'At least partially proficient on statewide core assessments or body of evidence' },
  { state: 'Connecticut', assessment: 'LAS Links', overallScore: 'Overall Level 4', additional: 'Academic achievement and other local criteria' },
  { state: 'Delaware', assessment: 'WIDA ACCESS', overallScore: '4.7' },
  { state: 'Florida', assessment: 'WIDA ACCESS', overallScore: '4', domainSpecific: 'Minimum 4.0 in Reading', additional: 'ELL Committee can also exit students based on multiple measures' },
  {
    state: 'Georgia',
    assessment: 'WIDA ACCESS',
    overallScore: '5',
    additional: 'Clear exit at 5.0; districts may reclassify at 4.3–4.9 with additional local criteria',
  },
  {
    state: 'Hawaii',
    assessment: 'WIDA ACCESS',
    overallScore: '4.7',
    additional: '4.5–4.6 may exit with additional qualifying evidence',
  },
  {
    state: 'Idaho',
    assessment: 'WIDA ACCESS',
    overallScore: 'No overall cut (grades 1–12)',
    domainSpecific: 'Minimum 3.5 in three domains (Listening, Reading, Writing)',
    additional: 'Speaking minimum is 1.0, the lowest level. Kindergarten: 4.2 overall',
  },
  { state: 'Illinois', assessment: 'WIDA ACCESS', overallScore: '4.8' },
  { state: 'Indiana', assessment: 'WIDA ACCESS', overallScore: '5', additional: 'Scores of 4.3-4.9 eligible for additional evidence review by committee' },
  { state: 'Iowa', assessment: 'ELPA21', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains', additional: 'Teacher observations and recommendations considered' },
  { state: 'Kansas', assessment: 'KELPA', overallScore: 'Proficient', domainSpecific: 'Proficient in all domains' },
  { state: 'Kentucky', assessment: 'WIDA ACCESS', overallScore: '4.5' },
  { state: 'Louisiana', assessment: 'ELPA21', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains' },
  { state: 'Maine', assessment: 'WIDA ACCESS', overallScore: '4.5' },
  { state: 'Maryland', assessment: 'WIDA ACCESS', overallScore: '4.5' },
  { state: 'Massachusetts', assessment: 'WIDA ACCESS', overallScore: '4.2', domainSpecific: 'Minimum 3.9 in Literacy Composite' },
  { state: 'Michigan', assessment: 'WIDA ACCESS', overallScore: '4.8' },
  { state: 'Minnesota', assessment: 'WIDA ACCESS', overallScore: '4.5', domainSpecific: 'Minimum 3.5 in all four individual domains (Listening, Speaking, Reading, Writing)' },
  {
    state: 'Mississippi',
    assessment: 'LAS Links',
    overallScore: 'Overall Level 4 or 5',
    domainSpecific: 'Reading and Writing Level 4 or 5',
  },
  { state: 'Missouri', assessment: 'WIDA ACCESS', overallScore: '4.7' },
  { state: 'Montana', assessment: 'WIDA ACCESS', overallScore: '4.7' },
  { state: 'Nebraska', assessment: 'ELPA21', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains' },
  { state: 'Nevada', assessment: 'WIDA ACCESS', overallScore: '4.5', additional: 'Teacher recommendation and parent notification required' },
  { state: 'New Hampshire', assessment: 'WIDA ACCESS', overallScore: '4.5' },
  { state: 'New Jersey', assessment: 'WIDA ACCESS', overallScore: '4.5', additional: 'Classroom performance; reading level; state achievement tests' },
  { state: 'New Mexico', assessment: 'WIDA ACCESS', overallScore: '4.7' },
  { state: 'New York', assessment: 'NYSESLAT', overallScore: 'Commanding level', additional: 'Or Expanding level + passing English Regents/State Assessment' },
  { state: 'North Carolina', assessment: 'WIDA ACCESS', overallScore: '4.5' },
  {
    state: 'North Dakota',
    assessment: 'WIDA ACCESS',
    overallScore: '4.5',
    domainSpecific: 'Minimum 3.5 in all four individual domains (Listening, Speaking, Reading, Writing)',
  },
  { state: 'Ohio', assessment: 'OELPA', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains' },
  { state: 'Oklahoma', assessment: 'WIDA ACCESS', overallScore: '4.8', additional: 'Scores 4.3-4.7 eligible for band exit with OSTP ELA proficient score' },
  { state: 'Oregon', assessment: 'ELPA21', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains' },
  { state: 'Pennsylvania', assessment: 'WIDA ACCESS', overallScore: '4.5' },
  { state: 'Rhode Island', assessment: 'WIDA ACCESS', overallScore: '4.8' },
  { state: 'South Carolina', assessment: 'WIDA ACCESS', overallScore: '4.4' },
  { state: 'South Dakota', assessment: 'WIDA ACCESS', overallScore: '5' },
  {
    state: 'Tennessee',
    assessment: 'WIDA ACCESS',
    overallScore: '4.4',
    domainSpecific: 'Minimum 4.2 in Literacy Composite',
  },
  { state: 'Texas', assessment: 'TELPAS', overallScore: 'Advanced High', additional: 'Passing state STAAR test and LPAC committee approval' },
  {
    state: 'Utah',
    assessment: 'WIDA ACCESS',
    overallScore: '4.2',
    domainSpecific: 'Minimum 3.5 in Speaking domain',
    summary: '4.2 composite • 3.5 speaking',
  },
  {
    state: 'Vermont',
    assessment: 'WIDA ACCESS',
    overallScore: '5',
    additional: 'Grades 3–12 at 4.3–4.9 may exit through the state alternate pathway',
  },
  { state: 'Virginia', assessment: 'WIDA ACCESS', overallScore: '4.4' },
  {
    state: 'Washington',
    assessment: 'WIDA ACCESS',
    overallScore: '4.7',
    additional: 'Grades 3–12 (not 9) at 4.3–4.6 may exit with a state ELA (SBA) level 3 or 4',
  },
  { state: 'West Virginia', assessment: 'ELPA21', overallScore: 'Proficient', domainSpecific: 'Level 4 or 5 in all four domains' },
  {
    state: 'Wisconsin',
    assessment: 'WIDA ACCESS',
    overallScore: '5',
    additional: '5.0 must reclassify; districts may reclassify at 4.5–4.9 with a secondary measure of proficiency',
  },
  {
    state: 'Wyoming',
    assessment: 'WIDA ACCESS',
    overallScore: '4.6',
    domainSpecific: 'Minimum 4.3 in Literacy Composite',
  },
];
